import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.scrollToBottom()
    this.element.addEventListener("chat:new-message", this.scrollToBottomSmooth.bind(this));
  }

  scrollToBottom() {
    this.containerTarget.scrollTop = this.containerTarget.scrollHeight
  }

  scrollToBottomSmooth() {
    this.containerTarget.scrollTo({ top: this.containerTarget.scrollHeight, behavior: "smooth" });
  }
}
